export default __webpack_public_path__ + "static/media/b44.521b0f12.png";